import { gql } from '@apollo/client';

export const sessionsGql = gql`
  query sessions(
    $parkingId: String
    $limit: Int! = 50
    $page: Int! = 1
    $status: [String]
    $dateRangeStart: [String]
    $dateRangeEnd: [String]
    $type: [String]
    $device: [String]
    $contractId: String
  ) {
    sessions(
      parkingId: $parkingId
      limit: $limit
      page: $page
      status: $status
      dateRangeStart: $dateRangeStart
      dateRangeEnd: $dateRangeEnd
      type: $type
      device: $device
      contractId: $contractId
    ) {
      list {
        _id
        entryDate
        exitDate
        startDate
        parkingId
        currency
        contractId
        isInconsistent

        product {
          _id
          name
        }

        parking {
          _id
          accessPoints {
            shortCode
            _id
          }
        }

        contract {
          name1
          name2
          ospContractId
          category
        }

        events {
          accessPointId
          createdAt
          state
          reason
          amount
          credentials {
            type
            provider
            value
            description
          }
        }
      }

      paging {
        current
        count
        limit
      }
    }
  }
`;
